import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import RefreshIcon from '@mui/icons-material/Refresh';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export function NotificationTypography({ 
    color = "text.secondary", 
    Icon, 
    title,
    message, 
    description,
    showActions = false,
    backTo = "/",
    minHeight = "300px" 
}) {
    const navigate = useNavigate();

    const handleRefresh = () => {
        window.location.reload();
    };

    const handleGoBack = () => {
        navigate(backTo);
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            minHeight={minHeight}
            width="100%"
            textAlign="center"
            sx={{ py: 4 }}
        >
            {Icon && (
                <Icon 
                    sx={{ 
                        fontSize: 48, 
                        color: color === "error" ? "error.main" : 
                               color === "warning" ? "warning.main" :
                               color === "success" ? "success.main" : "text.secondary",
                        mb: 2 
                    }} 
                />
            )}
            
            {title && (
                <Typography variant="h6" gutterBottom>
                    {title}
                </Typography>
            )}
            
            <Typography 
                variant="body1" 
                color={color}
                sx={{ mb: description || showActions ? 2 : 0 }}
            >
                {message}
            </Typography>
            
            {description && (
                <Typography 
                    color="text.secondary" 
                    sx={{ mb: showActions ? 3 : 0, maxWidth: 500 }}
                >
                    {description}
                </Typography>
            )}
            
            {showActions && (
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <Button 
                        variant="outlined" 
                        onClick={handleRefresh}
                        startIcon={<RefreshIcon />}
                    >
                        Refresh Page
                    </Button>
                    <Button 
                        variant="contained" 
                        onClick={handleGoBack}
                        startIcon={<ArrowBackIcon />}
                    >
                        Go Back
                    </Button>
                </Box>
            )}
        </Box>
    );
}